import {Map, fromJS, List} from "immutable";

import {
    GET_ISSUES_SUCCESS,
    GET_ISSUES_REQUEST,
    GET_ISSUES_ERROR,

    GET_ISSUE_REQUEST,
    GET_ISSUE_SUCCESS,
    GET_ISSUE_ERROR,

    CREATE_ISSUE_REQUEST,
    CREATE_ISSUE_SUCCESS,
    CREATE_ISSUE_ERROR,

    UPDATE_ISSUE_REQUEST,
    UPDATE_ISSUE_SUCCESS,
    UPDATE_ISSUE_ERROR,

    UPLOAD_ISSUE_FILES_REQUEST,
    UPLOAD_ISSUE_FILES_PROGRESS,
    UPLOAD_ISSUE_FILES_SUCCESS,
    UPLOAD_ISSUE_FILES_ERROR,

    DELETE_ISSUE_FILE_REQUEST,
    DELETE_ISSUE_FILE_SUCCESS,
    DELETE_ISSUE_FILE_ERROR,

    DELETE_ISSUE_REQUEST,
    DELETE_ISSUE_SUCCESS,
    DELETE_ISSUE_ERROR,

    CLEAN_ISSUES
} from '../actions/issues';

const issues = (state = Map({
  payload: List([]),
  isFetching: false,
    isUploading: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_ISSUES_REQUEST:
      case GET_ISSUE_REQUEST:
      case CREATE_ISSUE_REQUEST:
      case UPDATE_ISSUE_REQUEST:
      case DELETE_ISSUE_FILE_REQUEST:
      case DELETE_ISSUE_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      case UPLOAD_ISSUE_FILES_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: true,
              error: action.error,
              percent: 0
          });
          return newState;

      // Progress
      case UPLOAD_ISSUE_FILES_PROGRESS:
          newState = state.merge({
              percent: action.percent
          });
          return newState;

      // Success
      case GET_ISSUES_SUCCESS:
      case GET_ISSUE_SUCCESS:
      case CLEAN_ISSUES:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_ISSUE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_ISSUE_SUCCESS:
      case UPLOAD_ISSUE_FILES_SUCCESS:
      case DELETE_ISSUE_FILE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  isUploading: false,
                  percent: 0,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_ISSUE_SUCCESS:
          updatedPayload = payload.filter( workReport => {
              return workReport.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_ISSUES_ERROR:
      case GET_ISSUE_ERROR:
      case CREATE_ISSUE_ERROR:
      case UPDATE_ISSUE_ERROR:
      case UPLOAD_ISSUE_FILES_ERROR:
      case DELETE_ISSUE_FILE_ERROR:
      case DELETE_ISSUE_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default issues;



// WEBPACK FOOTER //
// ./src/reducers/issues.js